<template>
  <div class="container-fluid">
    <div class="row">
      <b-modal size="md" hide-footer ref="FinancesTaxTypesModal">
        <template v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">
            {{ !!editedItem.id ? "Edit tax type" : "Create tax type" }}
          </h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
            <span class="material-icons">
              close
            </span>
          </button>
        </template>
        <FinancesTaxTypesForm
          :dataProps="editedItem"
          :isLoading="isLoading"
          @submit="onSubmit"
        />
      </b-modal>

      <div class="col-12">
        <div class="page-table-header">
          <div class="title-container">
            <h3 class="title log_time_head">
              Tax Types
              <div
                v-if="isLoading"
                class="spinner-border spinner-theme_default"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </h3>
            <div class="title-container__controls">
              <b-button
                variant="success"
                class="button"
                @click="editEntityModalOpen()"
                :disabled="isLoading"
              >
                Create
              </b-button>
            </div>
          </div>
          <TableForPage
            :tableData="taxTypes"
            :fields="table.fields"
            :slots="table.slots"
            @edit="editEntityModalOpen"
            :isEdit="true"
            @remove="deleteTaxType"
            :isRemove="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FinancesTaxTypesForm from '@components/forms/FinancesTaxTypesForm'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'

export default {
  name: 'FinancesTaxTypes',
  components: { TableForPage, FinancesTaxTypesForm },
  data () {
    return {
      isLoading: false,
      isOpenDialog: false,
      editedItem: {},
      table: {
        data: [],
        fields: [
          {
            key: 'tax_type_name',
            label: 'Name',
            sortable: true
          },
          {
            key: 'formula_percent',
            label: 'Formula percent'
          },
          {
            key: 'formula_fixed',
            label: 'Formula fixed'
          },
          {
            key: 'currency.code',
            label: 'Currency'
          },
          {
            key: 'comment',
            label: 'Comment'
          },
          {
            key: 'actions',
            label: 'Actions',
            class: 'column_action'
          }
        ],
        slot: []
      }
    }
  },
  computed: {
    ...mapGetters({
      taxTypes: 'finances/getTaxTypes'
    })
  },

  mounted () {
    this.fetchTaxTypes()
  },

  methods: {
    fetchTaxTypes () {
      this._toggleDataPageLoading(() => this.$api.finances.getTaxTypes())
    },
    editEntityModalOpen (item) {
      if (item) {
        this.editedItem = item
      } else {
        this.editedItem = {}
      }

      this.isOpenDialog = true
      this.$refs['FinancesTaxTypesModal'].show()
    },

    async onSubmit (data) {
      if (this.editedItem.id) {
        await this.updateTaxType({ ...data, id: this.editedItem.id })
      } else {
        await this.createTaxType(data)
      }
      this.fetchTaxTypes()
    },

    async createTaxType (data) {
      this.isLoading = true

      return this.axios
        .post(
          '/api/finances/tax-types',
          data,
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(({ data }) => {
          this.$store.dispatch('finances/addTaxType', data)

          this.$snotify.success(
            'Tax type successfully created',
            'Success',
            this.$store.state.snotify
          )

          this.isOpenDialog = false
          this.editedItem = {}
          this.$refs['FinancesTaxTypesModal'].hide()
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async updateTaxType (data) {
      this.isLoading = true

      return this.axios
        .put(
          `/api/finances/tax-types/${this.editedItem.id}`,
          data,
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(({ data }) => {
          this.$store.dispatch('finances/editTaxType', data)

          this.$snotify.success(
            'Tax type successfully updated',
            'Success',
            this.$store.state.snotify
          )

          this.isOpenDialog = false
          this.editedItem = {}
          this.$refs['FinancesTaxTypesModal'].hide()
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async deleteTaxType (item) {
      this.isLoading = true

      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete?'
      )

      if (!confirm) {
        this.isLoading = false
        return
      }

      this.axios
        .delete(
          `/api/finances/tax-types/${item.id}`,
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(({ data }) => {
          this.$store.dispatch('finances/removeTaxType', parseInt(data.id))
          this.$snotify.success(
            'Tax type successfully deleted',
            'Success',
            this.$store.state.snotify
          )

          this.editedItem = {}
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style></style>
